import React from "react";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 16px;
    margin-bottom: 24px;

    @media (max-width: 1280px) { grid-template-columns: repeat(3, 1fr); }
    @media (max-width: 768px)  { grid-template-columns: repeat(2, 1fr); }

    .tile {
        background-color: #F5F7FB;
        border-radius: 12px;
        padding: 20px 16px;
        display: flex; flex-direction: column; gap: 8px;
        .label { color: #505050; font-size: 13px; font-weight: 500; }
        .value { color: #25368D; font-size: 28px; font-weight: 700; line-height: 1.2; }
        .sub   { color: #838BB4; font-size: 11px; }
    }
`;

const fmt = (v) => (v === null || v === undefined ? "-" : Number(v).toLocaleString("en-US"));
const pct = (v) => (v === null || v === undefined ? "-" : (Number(v) * 100).toFixed(1) + "%");

export default function KpiTiles({ summary }) {
    const s = summary || {};
    return (
        <Grid>
            <div className="tile"><div className="label">การส่งแบบสอบถาม</div><div className="value">{fmt(s.total_submissions)}</div></div>
            <div className="tile"><div className="label">การเข้าใช้บริการ</div>  <div className="value">{fmt(s.total_attendances)}</div></div>
            <div className="tile"><div className="label">ผู้ใช้งานที่ใช้งาน</div> <div className="value">{fmt(s.active_evaluators)}</div></div>
            <div className="tile"><div className="label">ผู้ใช้งานใหม่</div>     <div className="value">{fmt(s.new_evaluators)}</div></div>
            <div className="tile"><div className="label">อัตราตอบแบบสอบถาม</div><div className="value">{pct(s.submission_rate)}</div><div className="sub">submissions / attendances</div></div>
            <div className="tile"><div className="label">เฉลี่ย/ผู้ใช้งาน</div>  <div className="value">{fmt(s.avg_submissions_per_evaluator)}</div></div>
        </Grid>
    );
}
